const instinctGroove = {
  slug: "instinct-groove",
  layout: "instinct",
  title: "Instinct Groove",
  category: "Web Development / WebGL",
  client: "Instinct Groove",
  duration: "Ongoing",
  date: "2026 — Present",
  location: "Ottawa, Canada",
  cover: "/assets/instinct/card-room.webp",
  gallery: [],
  relatedSlugs: ["frequency-shift", "2024-chasing-greatness", "beatport-redesign"],
  liveUrl: "https://instinctgroove.com/",
  content: {
    hero: {
      dek: "Instinct Groove is a minimal tech and house series in Ottawa. This wall is the 3D environment I built for its site.",
      still: "/assets/instinct/hero-room.webp",
    },
    about: "I designed and built the website.",
  },
  seo: {
    title: "Instinct Groove — Web Development & WebGL by Matia Dosen",
    description: "Design and development of instinctgroove.com for an Ottawa minimal tech and house series, and its real-time 3D environment: the anniversary poster rebuilt as a lit room.",
    image: "/assets/instinct/card-lit.webp",
  },
}

export default instinctGroove
